import { SvgIcon } from '@mui/material';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { paths, permissions } from 'src/paths';

const {
  READ_PATIENT,
  READ_DAILY_SESSION_NOTES,
  READ_DASHBOARD,
  READ_DEPARTMENT_DASHBOARD,
  READ_MONTH_END_ALERT,
  READ_MY_AVAILABILITY,
  READ_THERAPIST_PLANNING,
  READ_THERAPIST_SCHEDULING,
  LABOR_MANAGEMENT,
} = permissions;

import { useSelector } from 'react-redux';
import {
  DailySessionNotesIcon,
  LaborManagementIcon,
  MonthEndAlertIcon,
  MyDashboardHomeIcon,
  MyDepartmentDashboardIcon,
  PatientIcon,
  ReportsIcon,
  SchedulingIcon,
} from './SideBarIcon/sideBarIcon';
import { title } from 'process';

export interface Item {
  disabled?: boolean;
  external?: boolean;
  icon?: ReactNode;
  items?: Item[];
  label?: ReactNode;
  path?: string;
  title: string;
}

export interface Section {
  items: Item[];
  subheader?: string;
}

export const useSections = () => {
  const { t } = useTranslation();
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );

  const thePayComeDetailsReducer = useSelector(
    (state: any) => state.thePayComeDetailsReducer?.response?.data
  );

  return useMemo(() => {
    const sidebarList = [
      {
        subheader: t('Dashboards'),
        items: [
          {
            title: t('My Dashboard'),
            path: paths.dashboard,
            icon: (
              // <SvgIcon fontSize="medium">
              <MyDashboardHomeIcon />
              // </SvgIcon>
            ),
          },
          {
            title: t('Department’s Dashboard'),
            path: paths.departmentDashboard,
            icon: (
              // <SvgIcon fontSize="medium">
              <MyDepartmentDashboardIcon />
              // </SvgIcon>
            ),
          },
          {
            title: t('Physician Dashboard'),
            path: paths.physicianDashboard,
            icon: (
              <SvgIcon fontSize="medium">
                <MyDepartmentDashboardIcon />
              </SvgIcon>
            ),
          },
        ],
      },
      {
        subheader: t('Actions'),
        items: [
          {
            title: t('Patients'),
            path: paths.patients,
            icon: (
              // <Sv fontSize="medium">
              <PatientIcon />
            ),
          },
          {
            title: t('Daily Notes and Billing'),
            path: paths.dailySessionNotes,
            icon: (
              // <SvgIcon fontSize="medium">
              <DailySessionNotesIcon />
              // </SvgIcon>
            ),
          },
          {
            title: t('Scheduling'),
            path: paths.schedule.index,
            icon: (
              // <SvgIcon fontSize="medium">
              <SchedulingIcon />
              // </SvgIcon>
            ),
            items: [
              {
                title: t('Therapy Planning'),
                path: `${paths.therapyPlanning.index}${paths.therapyPlanning.details}${paths.therapyPlanning.info}`,
              },
              {
                title: t('Therapist Scheduling'),
                path: `${paths.schedule.index}/${paths.schedule.therapistSchedule}`,
              },
            ],
          },
          {
            title: t('Labor Management'),
            path: paths.laborManagement.index,
            icon: (
              // <SvgIcon fontSize="medium">
              <LaborManagementIcon />
              // </SvgIcon>
            ),
            items: [
              {
                title: t('My Availability'),
                path: `${paths.laborManagement.index}/${paths.laborManagement.myAvailability}`,
              },
              {
                title: t('Labor Hour Management'),
                path: `${paths.laborManagement.index}/${paths.laborManagement.laborHoursManagement}`,
              },
              // {
              //   title: t('Labour Hour Management'),
              //   path: `${paths.laborManagement.index}/${paths.laborManagement.laborHoursManagement}`,
              // },
              // {
              //   title: t('Clock in/out'),
              //   path: `${paths.laborManagement.index}/${paths.laborManagement.checkInCheckOut}`,
              // },
              // {
              //   title: t('Labor Report and Approval'),
              //   path: `${paths.laborManagement.index}/${paths.laborManagement.laborReportAndApproval}`,
              // },
            ],
          },
          // {
          //   title: t('Month-End Alerts'),
          //   path: paths.monthDayAlert,
          //   icon: (
          //     <SvgIcon fontSize="medium">
          //       <MonthEndAlertIcon />
          //     </SvgIcon>
          //   ),
          // },
          {
            title: t('Monthly Closeout Alerts'),
            path: paths.monthlyCloseoutAlert,
            icon: (
              // <SvgIcon fontSize="medium">
              <MonthEndAlertIcon />
              // </SvgIcon>
            ),
          },
          {
            title: t('Reports'),
            path: paths.reports,
            icon: (
              // <SvgIcon fontSize="medium">
              <ReportsIcon />
              // </SvgIcon>
            ),
          },
        ],
      },
      // {
      //   subheader: t('RESTORE Integrations'),
      //   items: [
      //     {
      //       title: t('RESTORE Skills'),
      //       path: paths.restoreSkill,
      //       icon: (
      //         <SvgIcon fontSize="medium">
      //           <RSSkillIcon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t('RESTORE Care'),
      //       path: paths.restoreCare,
      //       icon: (
      //         <SvgIcon fontSize="medium">
      //           <SkillRCIcons />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t('RESTORE Wellness'),
      //       path: paths.restoreWellness,
      //       icon: (
      //         <SvgIcon fontSize="medium">
      //           <RWSkillIcon />
      //         </SvgIcon>
      //       ),
      //     },
      //   ],
      // },
    ];
    const protectedSidebarList: any = sidebarList?.map((list) => {
      if (
        list?.subheader === 'Dashboards' &&
        (permissionData?.includes(READ_DASHBOARD) ||
          permissionData?.includes(READ_DEPARTMENT_DASHBOARD) ||
          permissionData?.includes('Physician Dashboard'))
      ) {
        return {
          subheader: t('Dashboards'),
          items: list?.items?.filter((dashboardsList) => {
            if (
              dashboardsList?.title === 'My Dashboard' &&
              !permissionData?.includes(READ_DASHBOARD)
            )
              return false;
            else if (
              dashboardsList?.title === 'Physician Dashboard' &&
              !permissionData?.includes('Physician Dashboard')
            )
              return false;
            else if (
              dashboardsList?.title === 'Department’s Dashboard' &&
              !permissionData?.includes(READ_DEPARTMENT_DASHBOARD)
            )
              return false;
            return true;
          }),
        };
      } else if (
        list?.subheader === 'Dashboards' &&
        !(
          permissionData?.includes(READ_DASHBOARD) ||
          permissionData?.includes(READ_DEPARTMENT_DASHBOARD)
        )
      )
        return {
          subheader: t('Dashboards'),
          lists: [],
        };

      if (list?.subheader === 'Actions') {
        const updatedActions: any = [];
        list?.items?.map((action) => {
          if (action?.title === 'Patients' && permissionData?.includes(READ_PATIENT))
            updatedActions.push(action);
          if (
            action?.title === 'Daily Notes and Billing' &&
            permissionData?.includes(READ_DAILY_SESSION_NOTES)
          )
            updatedActions.push(action);
          if (
            action?.title === 'Scheduling' &&
            (permissionData?.includes(READ_THERAPIST_SCHEDULING) ||
              permissionData?.includes(READ_THERAPIST_PLANNING))
          )
            updatedActions.push({
              title: t('Scheduling'),
              path: paths.schedule.index,
              icon: (
                // <SvgIcon fontSize="medium">
                <SchedulingIcon />
                // </SvgIcon>
              ),
              items: action?.items?.filter((schedule) => {
                if (
                  schedule?.title === 'Therapy Planning' &&
                  !permissionData?.includes(READ_THERAPIST_PLANNING)
                )
                  return false;
                if (
                  schedule?.title === 'Therapist Scheduling' &&
                  !permissionData?.includes(READ_THERAPIST_SCHEDULING)
                )
                  return false;
                return true;
              }),
            });

          if (
            action?.title === 'Labor Management' &&
            (permissionData?.includes(READ_MY_AVAILABILITY) ||
              permissionData?.includes(LABOR_MANAGEMENT))
          )
            updatedActions.push({
              title: t('Labor Management'),
              path: paths.laborManagement.index,
              icon: (
                <SvgIcon fontSize="medium">
                  <LaborManagementIcon />
                </SvgIcon>
              ),
              items: action?.items?.filter((schedule) => {
                if (
                  schedule?.title === 'My Availability' &&
                  !permissionData?.includes(READ_MY_AVAILABILITY)
                )
                  return false;
                // if (
                //   schedule?.title === 'Labor Hour Management' &&
                //   (thePayComeDetailsReducer?.enablePaycom ||
                //     thePayComeDetailsReducer?.enableHostedTime)
                // )
                //   return false;
                if (
                  schedule?.title === 'Labor Hour Management' &&
                  !permissionData?.includes(LABOR_MANAGEMENT)
                )
                  return false;

                return true;
              }),
            });

          // if (
          //   action?.title === 'Month-End Alerts' &&
          //   permissionData?.includes(READ_MONTH_END_ALERT)
          // )
          //   updatedActions.push(action);

          if (
            action?.title === 'Monthly Closeout Alerts' &&
            permissionData?.includes(READ_MONTH_END_ALERT)
          )
            updatedActions.push(action);
        });
        return {
          subheader: t('Actions'),
          items: updatedActions,
        };
      }

      return list;
    });

    return protectedSidebarList;
  }, [t, permissionData]);
};
